import clsx from 'clsx';
import { Dialog, DialogContent, DialogTrigger } from './Modal';
import { ConfirmationDialog } from './ConfirmationDialog';

export const RetailDriverActionButton = ({
  title,
  content,
  className,
  openModal,
  setOpenModal,
  handleOkClick,
}) => {
  return (
    <Dialog open={openModal} onOpenChange={(open) => setOpenModal(open)}>
      <DialogTrigger className={clsx('body-text w-full', className)}>
        {title}
      </DialogTrigger>
      <DialogContent>
        <ConfirmationDialog
          message={content}
          handleOkClick={handleOkClick}
          handleCancelClick={() => setOpenModal(false)}
        />
      </DialogContent>
    </Dialog>
  );
};
